import { component } from 'picoapp'
import { get } from '../lib/ajax'
import $ from 'quantdom'
import picoApp from '../lib/pico-init'

export default component((node) => {
  const isActive = $(node).attr('aria-selected')
  if (isActive === 'true') {
    const collectionUrl = $(node).attr('href')
    const title = $(node).text()
    document.title = `${title} | Solawave`

    get(collectionUrl)
      .then((res) => {
        history.pushState({ title, collectionUrl }, '', collectionUrl)
      })
      .catch((err) => {
        console.error('Could not get collection', err)
      })

    // const cached = sessionStorage.getItem(`_${collectionUrl}`)
    // if (cached) {
    //   history.pushState({ title, collectionUrl }, '', collectionUrl)
    // } else {
    //   get(collectionUrl)
    //     .then((res) => {
    //       history.pushState({ title, collectionUrl }, '', collectionUrl)
    //       sessionStorage.setItem(`_${collectionUrl}`, res)
    //     })
    //     .catch((err) => {
    //       console.error('Could not get collection', err)
    //     })
    // }
  }

  const handleClick = (e) => {
    e.preventDefault()

    const collectionUrl = $(e.target).attr('href')
    // const cached = sessionStorage.getItem(`_${collectionUrl}`)
    const title = $(e.target).text()
    const currentEl = $(e.target).parent('nav').find('a[aria-selected="true"]')
    currentEl.attr('aria-selected', false)
    $(e.target).attr('aria-selected', true)

    get(collectionUrl)
      .then((res) => {
        replaceHTML(collectionUrl, title, res)
      })
      .catch((err) => {
        $(e.target).attr('aria-selected', false)
        currentEl.attr('aria-selected', true)
        console.error('Could not get collection', err)
      })

    // if (cached) {
    //   replaceHTML(collectionUrl, title, cached)
    // } else {
    //   get(collectionUrl)
    //     .then((res) => {
    //       replaceHTML(collectionUrl, title, res)
    //     })
    //     .catch((err) => {
    //       $(e.target).attr('aria-selected', false)
    //       currentEl.attr('aria-selected', true)
    //       console.error('Could not get collection', err)
    //     })
    // }

    if (window?.gtag) {
      window.gtag('event', 'Collection Category Tab Click', {
        event_detail: title,
        event_detail2: collectionUrl,
      })
    }
  }

  $(node).on('click', handleClick)

  return () => {
    $(node).off('click', handleClick)
  }
})

function replaceHTML(collectionUrl, title, res, pushState = true) {
  const parser = new DOMParser()
  const doc = parser.parseFromString(res, 'text/html')
  doc.querySelector('.js-collection-header').remove()
  const el = doc.querySelector('.collection-main')
  const html = el.innerHTML
  const children = $('.collection-main').el().children
  const childrenToRemove = Array.from(children).slice(1)
  childrenToRemove.forEach((child) => {
    child.remove()
  })

  $('.js-collection-header').after(html)
  picoApp.mount()
  window?.StampedFn?.reloadUGC()

  document.title = `${title} | Solawave`

  if (pushState) {
    history.pushState({ title, collectionUrl }, '', collectionUrl)
  }

  // sessionStorage.setItem(`_${collectionUrl}`, res)
}

window.addEventListener('popstate', ({ state }) => {
  if (!state) return
  const { title, collectionUrl } = state
  // const cached = sessionStorage.getItem(`_${collectionUrl}`)
  const currentEl = $(`.js-collection-header-nav a[aria-selected="true"]`)
  const el = $(`.js-collection-header-nav a[href="${collectionUrl}"]`)
  currentEl.attr('aria-selected', false)
  el.attr('aria-selected', true)

  get(collectionUrl)
    .then((res) => {
      replaceHTML(collectionUrl, title, res, false)
    })
    .catch((err) => {
      console.error('Could not get collection', err)
      el.attr('aria-selected', false)
      currentEl.attr('aria-selected', true)
    })

  // if (cached) {
  //   replaceHTML(collectionUrl, title, cached, false)
  // } else {
  //   get(collectionUrl)
  //     .then((res) => {
  //       replaceHTML(collectionUrl, title, res, false)
  //     })
  //     .catch((err) => {
  //       console.error('Could not get collection', err)
  //       el.attr('aria-selected', false)
  //       currentEl.attr('aria-selected', true)
  //     })
  // }
})
